import { IHeaderOption } from 'props';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Content } from '../styles';
import { useAuth } from '../../../context';
import { ProfileType, TypeUser } from '../../../types/enums';

export function MenuOptionLeftUser() {
  const activePath = useLocation()?.pathname?.split('/')?.[1];
  const { user } = useAuth();

  const routes: IHeaderOption[] = useMemo(
    () => [
      {
        enabled: false,
        name: 'Meu Perfil',
        path: '/profileusercompany',
      },
      {
        name: 'Notificações',
        path: '/notification',
      },
      {
        name: 'Meus valores',
        path: '/myvalues',
        enabled:
          user.type !== TypeUser.COLLABORATOR ||
          user.collaboratorInfo?.profileType === ProfileType.OPERATOR,
      },
      {
        name: 'Carteira',
        path: '/wallet',
        enabled: user.type !== TypeUser.COLLABORATOR,
      },
    ],
    [user],
  );

  return (
    <Container>
      <h1 className="Title">Minha Conta</h1>
      <Content>
        <nav className="NavBar">
          {routes
            .filter((r) => r.enabled !== false)
            .map(({ path, name }) => (
              <div key={path} className="DivOption">
                <Link
                  className={`LinkMenuLeft ${path.includes(activePath) ? 'active' : ''}`}
                  to={path}>
                  {name}
                </Link>
              </div>
            ))}
        </nav>
      </Content>
    </Container>
  );
}
